<div class="col-12 pt-5">
    <i class="fa fa-times" (click)="onCloseDialog()"></i>
    <iframe [src]="data.pdfSrc"></iframe>
</div>